Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryReviewView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary_review']
  className: 'summary-review'

  initialize: ({ticketSummary}) ->
    @ticketSummary = ticketSummary
    @review = ticketSummary.get 'review'

  render: ->
    @$el.html @template
      reviewSubject: @_subject()
      reviewSubjectMetadata: @_subjectMetadata()
    @$el.find('#subject-metadata-separator').hide() if !@_subjectMetadata()
    @_getStars()
    @

  _subject: ->
    return @review.subject

  _subjectMetadata: ->
    return @review.subject_metadata

  _getStars: ->
    reviewStarsView = new Monitoring.Views.ReviewStarsView()
    @$el.find('#comment-review-stars').html(reviewStarsView.render().el)
    reviewStarsView.setRating(@_starRating())
    @$el.addClass({
      'apple_app_store_review_comment': 'apple_app_store',
      'gp_review_comment': 'google_play',
      'google-my-business-review': 'google_my_business'
    }[@ticketSummary.get('sub_type')])

  _starRating: ->
    return @review.stars
